// **Redux Imports
import { createSlice } from '@reduxjs/toolkit'

// constants
const initialAiHistoryState = {
  page: 0,
  offset: 10,
  sortBy: 'id',
  sortOrder: 'desc',
  toDate: '',
  fromDate: '',
  features: []
}

export const AiTokenHistorySlice = createSlice({
  name: 'aiTokenHistory',
  initialState: {
    historyFilters: { ...initialAiHistoryState }
  },
  reducers: {
    setAiHistoryFilters(state, action) {
      state.historyFilters = action.payload
    },
    resetAiHistoryFilters(state) {
      state.historyFilters = { ...initialAiHistoryState }
    }
  }
})

export const { setAiHistoryFilters, resetAiHistoryFilters } =
  AiTokenHistorySlice.actions

export default AiTokenHistorySlice.reducer
